export const permission=[
    {id: 1,label: '首页',path:"/",meta:{icon:"HomeFilled",title:"首页"}},
    // {id:200,label: '看板管理',meta:{icon:"Menu",title:"看板管理"},
    //     children:[
    //         {id:201,path:"/saleOrder",meta:{icon:"Menu",title:"销售看板"},label:"销售看板"},
    //     ]
    // },
    // {id:3,label: '物流管理', meta:{icon:"Van",title:"物流管理"},
    //     children:[
    //         //{id:5,path:"/",meta:{icon:"Menu",title:"头程费用"},label:"头程费用"},
    //         {id:302,path:"/contrast",meta:{icon:"Menu",title:"尾程费用"},label:"尾程费用"},
    //         //{id:7,path:"/",meta:{icon:"Menu",title:"费用定义"},label:"费用定义"},
    //         //{id:8,path:"/",meta:{icon:"Menu",title:"仓库管理"},label:"仓库管理"},
    //         //{id:9,path:"/",meta:{icon:"Menu",title:"物流商列表"},label:"物流商列表"},
    //     ]
    // },
    {id:4,label: '美国售后仓',meta:{icon:'Service',title:"美国售后仓"},
        children:[
            {id:401,path:"/activeSale",meta:{icon:"Menu",title:"保修激活"},label:"保修激活"},
            {id:102,path:"/unMatchSale",meta:{icon:"Menu",title:"未匹配列"},label:"未匹配列"},
            {id:403,path:"/signReceipt",meta:{icon:"Menu",title:"订单签收"},label:"订单签收"},
            {id:404,path:"/platformReceipt",meta:{icon:"Menu",title:"平台签收"},label:"平台签收"},
            {id:405,path:"/pcTempInStore",meta:{icon:"Menu",title:"临时入库"},label:"临时入库"},
            {id:406,path:"/toDoListPc",meta:{icon:"Menu",title:"待办签收"},label:"待办签收"},
            {id:407,path:"/orderResendEmail",meta:{icon:"Menu",title:"重发单邮件"},label:"重发单邮件"},
            {id:408,path:"/orderSend",meta:{icon:"Menu",title:"仓库发货"},label:"仓库发货"},
            {id:409,path:"/ZohoCrm",meta:{icon:"Menu",title:"预约安装"},label:"预约安装"},
            {id:410,path:"/operateList",meta:{icon:"Menu",title:"操作记录"},label:"操作记录"},
            {id:411,path:"/allSignAndInstoreLog",meta:{icon:"Menu",title:"出入库明细"},label:"出入库明细"},

        ]
    },
    {id:5,label: '渠道发货',meta:{icon:'Stamp',title:"渠道发货"},
        children:[
            // {id:501,path:"/stampConfig",meta:{icon:"Menu",title:"渠道配置"},label:"渠道配置"},
            // {id:502,path:"/bbyChannel",meta:{icon:"Menu",title:"BBY卡派发货"},label:"BBY卡派发货"},
            // {id:503,path:"/shopifyChannel",meta:{icon:"Menu",title:"Shopify卡派发货"},label:"Shopify卡派发货"},
            {id:504,path:"/mabangToKindee",meta:{icon:"Menu",title:"线下品牌推单"},label:"线下品牌推单"},
            //{id:13,path:"/",meta:{icon:"Menu",title:"售后维修"},label:"售后维修"},
        ]
    },
    // {id:6,label: '组织架构',meta:{icon:'Notebook',title:"组织架构"},
    //     children:[
    //         {id:601,path:"/kMumber",meta:{icon:"Menu",title:"账号管理"},label:"账号管理"},
    //         {id:602,path:"/kDepartment",meta:{icon:"Menu",title:"部门管理"},label:"部门管理"},
    //         //{id:18,path:"/",meta:{icon:"Menu",title:"菜单配置"},label:"菜单配置"},
    //     ]
    // },
    {id:7,label: '基础数据', meta:{icon:'Operation',title:"基础数据"},
        children:[
            // {id:701,path:"/orderPlatform",meta:{icon:"SuitcaseLine",title:"下单平台"},label:"下单平台"},
            // {id:702,path:"/comModity",meta:{icon:"Goods",title:"商品管理"},label:"商品管理"},
            {id:703,path:"/shopList",meta:{icon:"Menu",title:"店铺管理"},label:"店铺管理"},
        ]
    },
    {id:8,label: '品牌业务', meta:{icon:'Operation',title:"品牌业务"},
        children:[
            {id:801,path:"/shopVideo",meta:{icon:"VideoPlay",title:"分享视频"},label:"分享视频"},
            {id:802,path:"/shopifyOrder",meta:{icon:"TrendCharts",title:"销售线索"},label:"销售线索"},
            {id:803,path:"/shopifyProblem",meta:{icon:"Warning",title:"问题收集"},label:"问题收集"},
            {id:804,path:"/shopifyProdOri",meta:{icon:"Loading",title:"产品导向"},label:"产品导向"},
        ]
    },
    {id:9,label: 'EDI翻译',meta: {icon:'Document',title:"EDI翻译"},
        children: [
            {id:901,path: "/indexEdi",meta: {icon: "Menu", title: "销售列表"}},
            {id:902,path: "/addEdi",meta: {icon: "Menu", title: "EDI列表"}}
        ]
    }
    // {id:22,label: '数据管理',meta:{icon:'Document',title:"数据管理"},
    //     children:[
    //         {id:23,path:"/",meta:{icon:"Menu",title:"API管理"},label:"API管理"},
    //         {id:24,path:"/",meta:{icon:"Menu",title:"应用管理"},label:"应用管理"},
    //         {id:25,path:"/",meta:{icon:"Menu",title:"数据采集"},label:"数据采集"},
    //     ]
    // },
    //{id:26,label: 'OA流程',path:"/",meta:{icon:"Setting",title:"OA流程"}},
]
